import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";

export const fetchAdminDashboardData = async (token) => {
  try {
    const response = await api.get(API.dashboard.adminDashboard);
    return response.data;
  } catch (error) {
    console.error("Error fetching Admin dashboard data:", error);
    throw error;
  }
};
